export default {
  MONEY: 'money',
  IMPRESSIONS: 'impressions',
  CLICKS: 'clicks'
}
